var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.141,
    height: 56.141,
    viewBox: "0 0 56.141 56.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_10",
    "data-name": "Exclusion 10",
    d: "M20941.221-16807.207a27.406,27.406,0,0,1-10.732-2.166,27.524,27.524,0,0,1-8.764-5.908,27.5,27.5,0,0,1-5.908-8.764,27.4,27.4,0,0,1-2.166-10.732,27.406,27.406,0,0,1,2.166-10.732,27.524,27.524,0,0,1,5.908-8.764,27.524,27.524,0,0,1,8.764-5.908,27.406,27.406,0,0,1,10.732-2.166,27.4,27.4,0,0,1,10.732,2.166,27.5,27.5,0,0,1,8.764,5.908,27.524,27.524,0,0,1,5.908,8.764,27.406,27.406,0,0,1,2.166,10.732,27.4,27.4,0,0,1-2.166,10.732,27.5,27.5,0,0,1-5.908,8.764,27.5,27.5,0,0,1-8.764,5.908A27.4,27.4,0,0,1,20941.221-16807.207Zm-12.545-30.877a3.286,3.286,0,0,0-2.17.818,3.275,3.275,0,0,0-1.119,2.264,3.285,3.285,0,0,0,.811,2.395l10.035,11.467a3.3,3.3,0,0,0,2.424,1.125h.049c.064,0,.135,0,.229-.006a3.287,3.287,0,0,0,2.527-1.467l15.234-22.895a3.277,3.277,0,0,0,.486-2.479,3.267,3.267,0,0,0-1.406-2.1,3.27,3.27,0,0,0-1.824-.555,3.3,3.3,0,0,0-2.75,1.473l-12.844,19.307-7.2-8.223A3.31,3.31,0,0,0,20928.676-16838.084Z",
    transform: "translate(-20913.15 16862.848)",
    fill: "#17db9e",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.a032b4be3711f2dcf7a3ec32e53dff12.svg";
export { ForwardRef as ReactComponent };